module.exports = __webpack_public_path__ + "static/media/1-2.b9194a9c.mp3";